/**
 * Catalog delivery windows are persisted with Turkish unit tokens. Keep the
 * raw operational value intact and translate only those stable units at the UI
 * boundary so every package surface uses the same locale-safe rendering.
 */
const UNIT_MAP: Record<string, { saat: string; dk: string; gün: string }> = {
    en: { saat: "hours", dk: "min", gün: "days" },
    de: { saat: "Stunden", dk: "Min", gün: "Tage" },
    es: { saat: "horas", dk: "min", gün: "días" },
    fr: { saat: "heures", dk: "min", gün: "jours" },
    pt: { saat: "horas", dk: "min", gün: "dias" },
};

export function localizeDeliveryTime(value: string, locale: string): string {
    if (locale === "tr" || !UNIT_MAP[locale]) return value;
    const units = UNIT_MAP[locale];
    return value
        .replace(/saat/gi, units.saat)
        .replace(/dk/gi, units.dk)
        .replace(/gün/gi, units.gün);
}
